<div *ngIf="!isEdited" class="cell-view">
  <div class="inner-view">
    <span *ngIf="rowData[fieldName]">
      {{
        (rowData[fieldName][0] ? (rowData[fieldName][0] | date) : '') +
          ' - ' +
          (rowData[fieldName][1] ? (rowData[fieldName][1] | date) : '')
      }}
    </span>
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="DatePeriodCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="DatePeriodCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div *ngIf="isEdited" class="p-inputgroup">
    <p-calendar
      #calendarRef
      [name]="fieldName"
      dateFormat="dd.mm.yy"
      [style]="{ width: '100%' }"
      selectionMode="range"
      [inputStyle]="{ width: '100%', 'border-top-right-radius': '0px', 'border-bottom-right-radius': '0px' }"
      class="calendar-input-width-fix"
      [(ngModel)]="rowData[fieldName]"
      appendTo="body"
      [locale]="de"
      (click)="$event.stopPropagation()"
      (keyup.esc)="abortCellEdit($event)"
      (onSelect)="onDateSelect()"
      (onClose)="abortCellEdit($event)"
      jmlAutoFocus
    ></p-calendar>
    <button
      pButton
      type="button"
      icon="pi pi-check"
      (mousedown)="save()"
      [disabled]="
        !rowData[fieldName] ||
        (mandatory && !rowData[fieldName][1]) ||
        (!!rowData[fieldName][0] && !rowData[fieldName][1])
      "
    ></button>
  </div>
</ng-template>
